import { render, staticRenderFns } from "./CrearMentoreado.vue?vue&type=template&id=135bef6d&"
import script from "./CrearMentoreado.vue?vue&type=script&lang=js&"
export * from "./CrearMentoreado.vue?vue&type=script&lang=js&"
import style0 from "./CrearMentoreado.vue?vue&type=style&index=0&id=135bef6d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports